import { convertToZonedTimestamp } from "common/helpers/dateAndTimeHelpersV2"

export const ConfiguredChartAxis = (props: Record<string, unknown>): JSX.Element => {
    const {
      time_zone,
      loc = 'unknown',
      labels = [],
      overlapping,
      ticks,
      scale,
      sizer,
      format,
      scale_type,
      axis_settings 
    } = props || {}
    
 
    const axis = axis_settings?.[loc as keyof typeof axis_settings] || {}
  
    if (!loc || !labels || !ticks) return <></>
 
    return <>
      <div data-id='axis' data-inner={props?.inner} data-outer={props?.outer} data-axis={loc}   data-area={`axis-${loc}`} className={`${overlapping ? `has-overlapping-labels ` : ``}${sizer ?  'tick-sizer ' : ``}axis axis--${loc}${['left', 'right'].includes(loc) ? `` : ' inline'}`}>
        {ticks?.map((val, i, arr) => {
          const style = { position: 'absolute' }
          let label = labels?.[i] || 0
          if (Number(val)) val = Number(val)     
          if (['left', 'right'].includes(loc)) {
            style.top = `${scale?.(val) || 0}px`
          } else {
            style.left = `${scale?.(val) || 0}px`
          }
          if (format) label = format?.({ label, index: i, arr, props, axis }) || label
          else {
            if (scale_type === 'time') {
               
              const [date, time] = convertToZonedTimestamp(label as string | number | Date, time_zone || 'UTC', 'd MMM-h:mm a')?.split('-')
              if (i === 0) label =  <>{time}<br />{date}</>
              else {
                const prev_label = labels?.[i - 1]
                const [prev_date, prev_time] = convertToZonedTimestamp(prev_label as string | number | Date, time_zone || 'UTC', 'd MMM-h:mm a')?.split('-')
                
                label = <>
                  {time}{date !== prev_date ? <><br />{date}</> : ''}
                </>
              }
            }
          }
          return (
            <div key={`tick-${loc}-${i}`} data-axis={loc}  style={style} data-id='tick' className={`tick tick--${loc}${['left', 'right'].includes(loc) ? `` : ' inline'}`} data-tick={ticks?.[i]}>
              <div data-axis={loc} data-id='tick-label' className='inner' data-tick={val}>{label}</div>
            </div>
          )
        })}
      </div>
    </>
}


 